import { type RootState } from "../redux/store";
import { useSelector } from "react-redux";

export const selectUnitMode = (state: RootState) => state.imperialMetricData.unitMode;

export const useUnitMode = () => useSelector(selectUnitMode);
